import React from 'react';
import { Link } from "react-router-dom";
import config from 'src/config/config';
import styled, { css, withTheme } from 'styled-components';
import { theme } from 'styled-tools';
// import GamstopLogo from 'src/images/gamestop_png.png';
// import BegambleAwareLogo from 'src/images/be-gamble-awarewhite.png';
// import GameCareLogo from 'src/images/gamcare_logo.png';
import Intl from '../common/Intl'
import { Tittle as FooterTittle } from '../udb/commonStyle';
import { withAppContext } from 'src/store/initAppContext';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PlaceholderImage from 'src/components/Placeholder';
import FooterSeoLinks from './footer-seo-links31';
import { useSocialMediaLinks } from 'src/hooks/useSocialMediaLinks';

function FooterContainer(props: any) {
    const { app: { brandId }, theme } = props
    const { config: { showFooterNetbanking,showPartners,showFooterastropay,showBlog,showNews,showAffiliate,showPress,ShowPrincipalAwardLogo,showOnlyOnFomo,showFun88Sponcers,sponsorship,customercare,showhelpLink,showhterritories,showAgProvider,showSupernowaProvider,showFooterSeoLinks } } = theme;

    const {socialMediaLinks, loading, hasSocialLinks} = useSocialMediaLinks(brandId);

    // const hostname = window.location.hostname;
    const brandUrlConfig = {
        31: 'https://www.yolo247.live',
        32: 'https://www.yolo247club.com',
        33: 'https://m.iw247.com',
        34: 'https://www.betdaily.club',
        39: 'https://www.fomo7.co',
        40: 'https://www.fomo7.xyz',
        46: 'https://www.fun88.site',
        47: 'https://www.fun88.live',
    };

    const hostname = brandUrlConfig[brandId] || 'https://www.yolo247.live';

    return (
            <Container>
                <CopyRight>
                {ShowPrincipalAwardLogo &&
                    <>
                    {(showOnlyOnFomo) ? (
                        <SponsersWrapperFomo>
                            <div className='fomoSponsorColumn'>
                                <Link to="/sponsors">
                                    <LogoContain $propsAdd className="fomosponsor">
                                        <Tittle $propsAdd className='fomosponsorMargin'><Intl langKey="FOOTER@PrincipleSponcerFomo" /></Tittle>
                                        <LazyLoadImage src={`${config.imageV3Host}/static/media/principleSponcerFomo.png`} effect="none" width="50%" placeholder={<PlaceholderImage />} alt="Oficial Principle Sponsor" />
                                    </LogoContain>
                                    <CenterLine></CenterLine>
                                    <LogoContain $propsAdd>
                                        <Tittle $propsAdd><Intl langKey="FOOTER@OficialTittleSponcer" /></Tittle>
                                        <LazyLoadImage src={`${config.imageV3Host}/static/media/oficialTittleSponcer.png`} effect="none" width="80%" placeholder={<PlaceholderImage />} alt="Oficial Tittle Sponsor" />
                                    </LogoContain>
                                    <CenterLine></CenterLine>
                                    <LogoContain $propsAdd>
                                        <Tittle><Intl langKey="FOOTER@OfficialOverseasBackSponsor" /></Tittle>
                                        <LazyLoadImage src={`${config.imageV3Host}/static/media/officialOverseasBackSponsorF.png`} effect="none" width="70%" placeholder={<PlaceholderImage />} alt="Official Overseas Back Sponsor" />
                                    </LogoContain>
                                    <CenterLine></CenterLine>
                                    <LogoContain $propsAdd>
                                        <Tittle><Intl langKey="FOOTER@PrincipalSponsors" /></Tittle>
                                        <LazyLoadImage src={`${config.imageV3Host}/static/media/principalSponsorsFomodesk.png`} effect="none" width="80%" placeholder={<PlaceholderImage />} alt="principal sponsors" />
                                    </LogoContain>
                                </Link>
                            </div>
                            <div className='sponsorColumn'>
                                <Link to="/sponsors">
                                    <LogoContain $propsAdd>
                                        <Tittle><Intl langKey="FOOTER@PrinciplePartner" /></Tittle>
                                        <LazyLoadImage src={`${config.imageV3Host}/static/media/principlePartnerFomoNew.png`} effect="none" width="80%" placeholder={<PlaceholderImage />} alt="Principle Partner" />
                                    </LogoContain>
                                    <CenterLine></CenterLine>
                                    <LogoContain $propsAdd>
                                        <Tittle><Intl langKey="FOOTER@AssociatePartner" /></Tittle>
                                        <LazyLoadImage src={`${config.imageV3Host}/static/media/associatePartnerFomoNew.png`} effect="none" width="80%" placeholder={<PlaceholderImage />} alt="Associate Partner" />
                                    </LogoContain>
                                    <CenterLine></CenterLine>
                                    <LogoContain $propsAdd>
                                        <Tittle><Intl langKey="FOOTER@Associatesponsors" /></Tittle>
                                        <LazyLoadImage src={`${config.imageV3Host}/static/media/associateSponsorFomo.png`} effect="none" width="80%" placeholder={<PlaceholderImage />} alt="Associate sponsor" />
                                    </LogoContain>
                                </Link>
                            </div>
                        </SponsersWrapperFomo>
                    ) : (
                        <>
                            {showPartners ?
                                <SponsersWrapperFomo>
                                    <div className='sponsorColumn'>
                                        <Link to="/sponsors">
                                           <LogoContain $propsAdd>
                                                <Tittle><Intl langKey="FOOTER@BackJerseySponsor" /></Tittle>
                                                <LazyLoadImage src={`${config.imageV3Host}/static/media/yoloSponsorshipFooter01DC25.png`} effect="none" width="60%" placeholder={<PlaceholderImage />} alt="yolo Principle Sponsor" />
                                            </LogoContain>
                                            <CenterLine></CenterLine>
                                                <LogoContain $propsAdd>
                                                <Tittle><Intl langKey="FOOTER@FrontJerseySponsor" /></Tittle>
                                                <LazyLoadImage src={`${config.imageV3Host}/static/media/yoloSponsorshipFooter02DC25.png`} effect="none" width="60%" placeholder={<PlaceholderImage />} alt="yolo Principle Sponsor" />
                                            </LogoContain>
                                            <CenterLine></CenterLine>
                                            <LogoContain $propsAdd>
                                                <Tittle><Intl langKey="FOOTER@FrontJerseySponsor" /></Tittle>
                                                <LazyLoadImage src={`${config.imageV3Host}/static/media/trailblazersSponsorLogoFooter.png`} effect="none" width="60%" placeholder={<PlaceholderImage />} alt="yolo Principle Sponsor" />
                                            </LogoContain>
                                            <CenterLine></CenterLine>
                                            <LogoContain $propsAdd>
                                                <Tittle><Intl langKey="FOOTER@PrincipalSponsorsOne" /></Tittle>
                                                <LazyLoadImage src={`${config.imageV3Host}/static/media/PrincipleSponsor23Yolo.png`} effect="none" width="40%" placeholder={<PlaceholderImage />} alt="yolo Principle Sponsor" />
                                            </LogoContain>

                                        </Link>
                                    </div>
                                    <div className='sponsorColumn'>
                                        <Link to="/sponsors">
                                            <LogoContain>
                                                <Tittle><Intl langKey="FOOTER@PrincipalSponsorsTwo" /></Tittle>
                                                <FooterLogoWrap>
                                                    <div>
                                                        <LazyLoadImage src={`${config.imageV3Host}/static/media/DubaiCapitalsLogoNew.png`} width="100px" effect="none" placeholder={<PlaceholderImage />} alt="yolo Principle Sponsor" />
                                                        <LazyLoadImage src={`${config.imageV3Host}/static/media/yoloGames.png`} effect="none" width="60%" placeholder={<PlaceholderImage />} alt="yolo Principle Sponsor" />
                                                    </div>
                                                </FooterLogoWrap>
                                            </LogoContain>
                                            <CenterLine></CenterLine>
                                            <LogoContain $propsAdd>
                                                <Tittle><Intl langKey="FOOTER@PrincipalSponsorsThree" /></Tittle>
                                                <LazyLoadImage src={`${config.imageV3Host}/static/media/GwaliorCheetahsEngSponsor.png`} effect="none" width="60%" placeholder={<PlaceholderImage />} alt="yolo Principle Sponsor" />
                                            </LogoContain>
                                            <CenterLine></CenterLine>
                                            <LogoContain>
                                                <Tittle><Intl langKey="FOOTER@SeriesGoldSponsorOne" /></Tittle>
                                                <FooterLogoWrap>
                                                    <div>
                                                        <LazyLoadImage src={`${config.imageV3Host}/static/media/SeriesgoldSponnsorYolo.png`} width="75%" effect="none" placeholder={<PlaceholderImage />} alt="yolo Series Gold Sponsor" />
                                                    </div>
                                                </FooterLogoWrap>
                                            </LogoContain>
                                            <CenterLine></CenterLine>
                                            <LogoContain $propsAdd>
                                                <Tittle><Intl langKey="FOOTER@SeriesGoldSponsorTwo" /></Tittle>
                                                <LazyLoadImage src={`${config.imageV3Host}/static/media/SeriesgoldSponnsor2024Yolo.png`} effect="none" width="65%" placeholder={<PlaceholderImage />} alt="yolo Series Gold Sponsor" />
                                            </LogoContain>
                                        </Link>
                                    </div>
                                    <div className='sponsorColumn'>
                                         <Link to="/sponsors">
                                            <LogoContain $propsAdd className='customWidthSponsors'>
                                                <Tittle><Intl langKey="FOOTER@EngagementPartnerYolo" /></Tittle>
                                                <div className='customHeightSponsors'>
                                                   <LazyLoadImage src={`${config.imageV3Host}/static/media/EngagementPartnerYolo2025.png`} effect="none" width="100%" placeholder={<PlaceholderImage />} alt="yolo Engagement Partner" />
                                                </div>
                                            </LogoContain>
                                        </Link>
                                    </div>
                                </SponsersWrapperFomo>
                                : <></>
                            }
                        </>
                    )}
                    {showFun88Sponcers &&
                        <SponsersWrapperFun>
                            <div className='sponsorColumn'>
                                <Link to="/sponsors">
                                    <LogoContain $propsAdd>
                                        <LazyLoadImage src={`${config.imageV3Host}/static/media/fun88DubaiCapitalsSponsorLogo.png`} effect="none" width="100%" placeholder={<PlaceholderImage />} alt="Sponsor" />
                                        <FomoTittle><Intl langKey="FOOTER@MainPrincipalSponsor" /></FomoTittle>
                                        <FomoSubTittle>Dubai Capitals</FomoSubTittle>
                                    </LogoContain>
                                    <LogoContain $propsAdd>
                                        <LazyLoadImage src={`${config.imageV3Host}/static/media/fun88siliguriStrickersLogo.png`} effect="none" width="100%" placeholder={<PlaceholderImage />} alt="Sponsor" />
                                        <FomoTittle><Intl langKey="FOOTER@OfficialJerseySponsor" /></FomoTittle>
                                        <FomoSubTittle>Siliguri Strikers</FomoSubTittle>
                                    </LogoContain>

                                    <LogoContain $propsAdd>
                                        <LazyLoadImage src={`${config.imageV3Host}/static/media/funTitleSponsorSeason10.png`} effect="none" width="100%" placeholder={<PlaceholderImage />} alt="Sponsor" />
                                        <FomoTittle><Intl langKey="FOOTER@TitleSponsorSeason10" /></FomoTittle>
                                        <FomoSubTittle>Dabang Delhi K.C (DKCC)</FomoSubTittle>
                                    </LogoContain>
                                    <LogoContain $propsAdd>
                                        <LazyLoadImage src={`${config.imageV3Host}/static/media/officialGlobalAmbassador2023-25.png`} effect="none" placeholder={<PlaceholderImage />} alt="Sponsor" />
                                        <FomoTittle><Intl langKey="FOOTER@OfficialGlobalAmbassador2023-25" /></FomoTittle>
                                        <FomoSubTittle>Dale Steyn</FomoSubTittle>
                                    </LogoContain>
                                    <LogoContain $propsAdd>
                                        <LazyLoadImage src={`${config.imageV3Host}/static/media/officialShirtSponsorEPLfrom2017-20.png`} effect="none" placeholder={<PlaceholderImage />} alt="Sponsor" />
                                        <FomoTittle><Intl langKey="FOOTER@OfficialShirtSponsorEPLFrom2017-20" /></FomoTittle>
                                        <FomoSubTittle>Newcastle United F.C</FomoSubTittle>
                                    </LogoContain>
                                </Link>
                            </div>
                            <div className='sponsorColumn'>
                                <Link to="/sponsors">
                                    <LogoContain $propsAdd>
                                        <LazyLoadImage src={`${config.imageV3Host}/static/media/globalBrandAmbassador2023-24.png`} effect="none" placeholder={<PlaceholderImage />} alt="Sponsor" />
                                        <FomoTittle><Intl langKey="FOOTER@GlobalBrandAmbassador2023-24" /></FomoTittle>
                                        <FomoSubTittle>Iker Casillas</FomoSubTittle>
                                    </LogoContain>
                                    <LogoContain $propsAdd>
                                        <LazyLoadImage src={`${config.imageV3Host}/static/media/officialBettingPartnerSince2012.png`} effect="none" placeholder={<PlaceholderImage />} alt="Sponsor" />
                                        <FomoTittle><Intl langKey="FOOTER@OfficialBettingPartnerSince2012" /></FomoTittle>
                                        <FomoSubTittle>Tottenham Hotspur F.C</FomoSubTittle>
                                    </LogoContain>
                                    <LogoContain $propsAdd>
                                        <LazyLoadImage src={`${config.imageV3Host}/static/media/officialShirtSponsorBurnleyFC2015.png`} effect="none" placeholder={<PlaceholderImage />} alt="Sponsor" />
                                        <FomoTittle><Intl langKey="FOOTER@OfficialShirtSponsorBurnleyFCin2015" /></FomoTittle>
                                        <FomoSubTittle>Burnley F.C</FomoSubTittle>
                                    </LogoContain>
                                </Link>
                            </div>
                        </SponsersWrapperFun>
                    }
                    </>
                }

                { showFooterSeoLinks && <FooterSeoLinks/> }

                <Certificate>
                    <Tittle><Intl langKey="FOOTER@CERTIFICATIONS" /></Tittle>
                    {(brandId === 31 || brandId === 32) && <CertificateTitle><CertificateText><Intl langKey="FOOTER@CERTIFICATIONSTEXT" /></CertificateText></CertificateTitle>}
                    {(brandId === 39 || brandId === 40) && <CertificateTitle><CertificateText><Intl langKey="FOOTER@CERTIFICATIONSTEXT" /> </CertificateText> <CertificateText><Intl langKey="FOOTER@CERTIFICATIONSTEXT2" /></CertificateText></CertificateTitle>}

                    <CertificateImg>
                        <LazyLoadImage src={`${config.imageV3Host}/static/media/${theme.image.FooterGcbCertificateImg}`} effect="none" alt="gcb certificate" placeholder={<PlaceholderImage />} visibleByDefault={false} width="70%" />
                    </CertificateImg>
                </Certificate>

                    <Tittle><Intl langKey="FOOTER@GAMINGPARTNERS"/></Tittle>
                    <Link to="/live-casino/ezugi">
                        {<LazyLoadImage src={`${config.imageV3Host}/static/media/${theme.image.ezugiLogoNov24}`} effect="none" placeholder={<PlaceholderImage/>} visibleByDefault={false}/>}
                    </Link>
                    {showAgProvider && <Link to="/live-casino/ag"><LazyLoadImage src={`${config.imageV3Host}/static/media/aGLogoNew.png`} effect="none" placeholder={<PlaceholderImage/>} visibleByDefault={false}/></Link>}
                    <Link to="/live-casino/betgames"><LazyLoadImage src={`${config.imageV3Host}/static/media/betGamesLogoNew.png`} effect="none" placeholder={<PlaceholderImage/>} visibleByDefault={false}/></Link>
                    <Link to="/live-casino/evolution">
                        {<LazyLoadImage src={`${config.imageV3Host}/static/media/${theme.image.evolutionGamesNov24}`} effect="none" placeholder={<PlaceholderImage/>} visibleByDefault={false}/>}
                    </Link>
                    {/* <Link to="/live-casino/betsoft"><LazyLoadImage src={`${config.imageV3Host}/static/media/betSoftLogoNew.png`} effect="none" placeholder={<PlaceholderImage/>} visibleByDefault={false}/></Link> */}
                    <Link to="/slots/netent"><LazyLoadImage src={`${config.imageV3Host}/static/media/netentLogoNew.png`} effect="none" placeholder={<PlaceholderImage/>} visibleByDefault={false}/></Link>
                    <Link to="/live-casino/tvbet">
                        <LazyLoadImage src={`${config.imageV3Host}/static/media/${theme.image.tvbetLogoNov24}`}effect="none" placeholder={<PlaceholderImage/>} visibleByDefault={false}/>
                    </Link>
                    {/* <Link to="/slots/pragmatic"><LazyLoadImage src={`${config.imageV3Host}/static/media/pragmaticplayCasinosNew.png`} effect="none" placeholder={<PlaceholderImage/>} visibleByDefault={false}/></Link> */}
                    {/* <Link to="/slots/spinmatic"><LazyLoadImage src={`${config.imageV3Host}/static/media/spinmaticLogoNew.png`} effect="none" placeholder={<PlaceholderImage/>} visibleByDefault={false}/></Link> */}
                  {showSupernowaProvider && <Link to="/live-casino/supernowa"><LazyLoadImage src={`${config.imageV3Host}/static/media/supernowaLogoNew.png`} effect="none" placeholder={<PlaceholderImage />} visibleByDefault={false} /></Link>}
                   {/* <Link to="/live-casino/sexy-gaming"><LazyLoadImage src={`${config.imageV3Host}/static/media/sexygaminglogo.png`} effect="none" placeholder={<PlaceholderImage/>} visibleByDefault={false}/></Link> */}
                    <Link to="/bti-sportsbook"><LazyLoadImage src={`${config.imageV3Host}/static/media/BTILogoNew.png`} effect="none" placeholder={<PlaceholderImage/>} visibleByDefault={false}/></Link>
                    <Link to="/live-casino/7mojos"><LazyLoadImage src={`${config.imageV3Host}/static/media/7mojosIcon.png`} effect="none" placeholder={<PlaceholderImage/>} visibleByDefault={false}/></Link>
                    <Link to="/instant-games/spribe">
                        <LazyLoadImage src={`${config.imageV3Host}/static/media/${theme.image.spribeLogoFooterNov24}`} effect="none" placeholder={<PlaceholderImage/>} visibleByDefault={false}/>
                    </Link>
                </CopyRight>

                {brandId === 61 ?
                    <CopyRight>
                        <Tittle><Intl langKey="FOOTER@PAYMENTMETHODS"/></Tittle>
                        <NonClick><LazyLoadImage src={`${config.imageV3Host}/static/media/footerUsdtLogo.png`} effect="none" placeholder={<PlaceholderImage/>} visibleByDefault={false}/></NonClick>
                    </CopyRight> :
                     <CopyRight>
                        <Tittle><Intl langKey="FOOTER@PAYMENTMETHODS"/></Tittle>
                        {showFooterNetbanking && <NonClick><LazyLoadImage src={`${config.imageV3Host}/static/media/${theme.image.internetBankingNewNov24}`} effect="none" placeholder={<PlaceholderImage/>} visibleByDefault={false}/></NonClick>}
                        <NonClick><LazyLoadImage src={`${config.imageV3Host}/static/media/${theme.image.upiLogoNewNov24}`} effect="none" placeholder={<PlaceholderImage/>} visibleByDefault={false}/></NonClick>
                        <NonClick><LazyLoadImage src={`${config.imageV3Host}/static/media/${theme.image.gpayLogoNewNov24}`} effect="none" placeholder={<PlaceholderImage/>} visibleByDefault={false}/></NonClick>
                        <NonClick><LazyLoadImage src={`${config.imageV3Host}/static/media/paytmLogoNew.png`} effect="none" placeholder={<PlaceholderImage/>} visibleByDefault={false}/></NonClick>
                    {showFooterastropay && <NonClick><LazyLoadImage src={`${config.imageV3Host}/static/media/astropayLogoNew.png`} effect="none" placeholder={<PlaceholderImage/>} visibleByDefault={false}/></NonClick>}
                    </CopyRight>}

                {(hasSocialLinks && !loading) && (
                    <CopyRight>
                        <Tittle><Intl langKey="FOOTER@CONNECTWITHUS" /></Tittle>
                        <div className='socialMediaWrapper'>
                            {socialMediaLinks.map((item: any, index: number) => {
                                const { label, url, icon } = item;
                                return (
                                    <a href={url} target='_blank' rel="noreferrer" key={`${label}-${index}`}>
                                        <LazyLoadImage
                                            src={`${config.imageV3Host}${icon}`}
                                            effect="none"
                                            placeholder={<PlaceholderImage />}
                                            visibleByDefault={false}
                                            alt={label}
                                        />
                                    </a>
                                )
                            })}
                        </div>
                    </CopyRight>
                )}

                <CopyRight>
                    <a href="https://www.gamstop.co.uk/" target="_blank" rel="noreferrer"><LazyLoadImage src={`${config.imageV3Host}/static/media/gamestopLogo.png`} effect="none"  placeholder={<PlaceholderImage/>} visibleByDefault={false}/></a>
                    <a href="https://www.begambleaware.org/" target="_blank" rel="noreferrer"><LazyLoadImage src={`${config.imageV3Host}/static/media/${theme.image.beAwareLogoNov24}`} effect="none"   placeholder={<PlaceholderImage/>} visibleByDefault={false}/></a>
                    <a href="https://www.gamcare.org.uk/" target="_blank" rel="noreferrer"><LazyLoadImage src={`${config.imageV3Host}/static/media/${theme.image.gamcareLogoNov24}`} effect="none"  placeholder={<PlaceholderImage/>} visibleByDefault={false}/></a>
                    <Span><LazyLoadImage src={`${config.imageV3Host}/static/media/${theme.image.eighteenPlusLogoNov24}`} effect="none"  placeholder={<PlaceholderImage/>}/></Span>
                    <Span><Intl langKey="FOOTER@COPYRIGHT"/></Span>
                </CopyRight>

                {/* <CopyRight>
                    Yolo247 is a brand managed by SNK Entertainment N.V. (10692), a Curacao registered company whose registered address is 7 Abraham De Veerstraat, Curacao. <br/> SNK Entertainment N.V. Limited is licensed and regulated in Curacao by the Gaming Curacao.
                </CopyRight> */}
                <NewLogoWrapper>
                     {/* <LazyLoadImage src={`${config.imageV3Host}/static/cashsite/brand/6/icon/Gaming-Curacao-Logo.png`} effect="none" placeholder={<PlaceholderImage/>} visibleByDefault={false}/> */}
                </NewLogoWrapper>

                <PolicyWrapper>
                <Link to="/about/terms-conditions">	 <Intl langKey="FOOT@TERMSANDCONDITIONS" />  |  </Link>
                <Link to="/about/responsible-gambling">  <Intl langKey="FOOT@RESPONSIBLEGAMBLING" />  | </Link>
                <Link to="/about/privacy-policy">	  <Intl langKey="FOOT@PRIVACYPOLICY" />  | </Link>
                {/* <Link to="/about/disconnection-policy">  <Intl langKey="FOOT@DISCONNECTPOLICY" /> | </Link> */}
                <Link to="/about/kyc-policy">  <Intl langKey="FOOT@KYCPOLICY" />  | </Link>
                <Link to="/about/self-exclusion-policy">  <Intl langKey="FOOT@EXCLUSIONPOLICY" />  | </Link>
                <Link to="/about/aml-policy"> <Intl langKey="FOOT@AMLpolicy" /> |  </Link>
                <Link to="/about/rules-regulations"> <Intl langKey="FOOT@RULES" /> |  </Link>
                <Link to="/about/about-us">  <Intl langKey="FOOT@ABOUTUS" />  | </Link>
                <Link to="/about/faq">  <Intl langKey="FOOT@FAQ" />  | </Link>
                {showhterritories && <Link to="/about/restricted-territories"> <Intl langKey="FOOT@RESTRICTEDTERRITORIES" /> |  </Link>}
                {showAffiliate && <Link to='/affiliate'><Intl langKey="Header@Affiliate" /></Link> }
               {showBlog && <a href={`${hostname}/blog/`}> | <Intl langKey="FOOT@blog" /> </a> }
               {showNews && <a href="https://www.yolo247.news/"> | <Intl langKey="FOOT@news" /> </a> }
               {showPress && <a href={`${hostname}/press/`}> | <Intl langKey="FOOT@Press" /> </a> }
               {sponsorship && <a href={`${hostname}/sponsorship/`}> | <Intl langKey="FOOT@sponsorship" /> </a> }
               {customercare && <a href={`${customercare}`}> | <Intl langKey="FOOT@customercare" /> </a> }
               {showhelpLink && <a href='https://www.fun88.live/help/'> | <Intl langKey="FOOT@help" /> </a> }


                    {/* <Link to="/about/rules-regulations">  <Intl langKey="FOOT@RULES" /> |</Link>
                    <Link to="/about/restricted-territories">  <Intl langKey="FOOT@RESTRICTEDTERRITORIES" /> </Link> */}
                </PolicyWrapper>
            </Container>
    )
}

export default withTheme(withAppContext(FooterContainer));

//Styled Components

const CenterLine = styled.div`
    /* width: 2px; */
    height: 106px;
    padding: 0 1px;
    background: linear-gradient(180deg, #E6A238 0%, #FDEF9C 47.92%, #DB921A 100%);
    align-self: center;
`;

const LogoContain = styled.div<{ $propsAdd?: boolean }>`
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* gap: 1rem; */
    padding: 1rem;
    padding-top: 0;
    transition: all 0.2s ease-in-out 0s;
    justify-content: center;

    img {
      max-width: 100%;

        ${(props) => props.$propsAdd && css`
            width: 202px;
        `}
    }

    .fomosponsorMargin {
        margin-bottom: 1.5rem;
    }
`;

const SponsersWrapperFun = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    padding-top: 0;
    transition: all 0.2s ease-in-out 0s;

    a {
        width: 100% !important;
        align-items: flex-end !important;
    }

    .sponsorColumn, .fomoSponsorColumn {
        display: flex;
        align-items: flex-start;

        .fomosponsor {
            padding-bottom: 2.5rem;
        }

        a {
            width: 100% !important;
            align-items: flex-start !important;
        }
    }

    .customWidthSponsors{
        width: 400px;
    }
`;

const SponsersWrapperFomo = styled.div`
    width: 90%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    padding-top: 0;
    transition: all 0.2s ease-in-out 0s;

    .sponsorColumn, .fomoSponsorColumn {
        display: flex;
        align-items: flex-start;

        .fomosponsor {
            padding-bottom: 2.5rem;
        }

        a {
            width: 100% !important;
            align-items: flex-start !important;
        }
    }

    .customWidthSponsors{
        width: 400px;
    }

    .fomoSponsorColumn {
        width: 70%;
    }

    .customHeightSponsors{
        height: 120px;

        & img {
            width: 80%;
        }

    }
`;

const NonClick = styled.div`
    width: 8%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 10px;
    border-radius: 5px;
    transition: all 0.2s ease-in-out 0s;
`;

const CertificateImg = styled(NonClick)`
    width: 13%;
    padding: 5px 15px;

    a {
        width: 100% !important;
    }
`;

const Tittle = styled(FooterTittle)<{ $propsAdd?: boolean; }>`
    width: 100%;
    color: ${theme('palette.footerTittleColor')};
    text-transform: capitalize;
    font-weight: 500;
    font-size: 16px;
    text-align: center;
    margin-bottom: ${theme('palette.footerCertificationTextMarginBottom')};

    ${props => props.$propsAdd &&
    css`
        font-size: 14px;
    `};
`;

const FomoTittle = styled(FooterTittle)`
    width: 100%;
    color: ${theme('palette.footerTittleColor')};
    text-transform: capitalize;
    font-weight: 500;
    font-size: 16px;
    text-align: center;
    margin-bottom: 10px;
    font-weight: bold;
`;

const FomoSubTittle: any = styled.div`
    width: 100%;
    color: #888;
    text-transform: capitalize;
    font-weight: 500;
    font-size: 15px;
    text-align: center;
    margin-bottom: 10px;
    font-weight: bold;
`;

const Container: any = styled.div`
    width: 100%;
    background: ${theme('palette.footerbgColor')};
    position: relative;
`;

const CopyRight = styled.div`
    width: 100%;
    display: flex;
	align-items:center;
	justify-content: center;
    flex-wrap: wrap;
    color: ${theme('palette.footerDefaultColor')};
    font-size: 15px;
    text-align: center;
	line-height: 20px;
	padding-left: 10px;
    /* padding: 30px; */
    padding: 30px 0;
    padding-bottom: 10px;
    margin: 0 auto;

	a {
        /* width: 122px; */
        width: 8%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 5px 10px;
        border-radius: 5px;
		transition: all 0.2s ease-in-out 0s;
	}

	a:hover {
        background-color: ${theme('palette.footerLogoHoverBg')};
	}

    img {
        max-width: 100%;
        transition: all 0.2s ease-in-out 0s;
    }

    .socialMediaWrapper {
        width: auto;
        display: flex;
        align-items: center;
        justify-content: center;

        a {
            width: 35px;
            height: 35px;
            margin: 0px 5px;
            display: flex;
            padding: 0;

            img {
                width: 100%;
                border: ${theme('palette.footerSocialMediaBorder')};
                border-radius: 20px;
            }

            :hover {
                background-color: transparent;

                img {
                    border: ${theme('palette.footerSocialMediaBorderHover')};
                }
            }
        }
    }
`;

const Certificate = styled(CopyRight)`
    padding: 5px 0 30px 0;

    .footerContactUs {
        flex-direction: row;
        padding-bottom: 10px;
    }
`;

const PolicyWrapper = styled.div`
    font-size: 15px;
	display: flex;
	justify-content:center;
	padding-bottom:20px;
	align-items: center;
	padding-left: 10px;
    width: 100%;
    margin: 0 auto;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;

    a {
        color: ${theme('palette.footerPolicyTextColor')};
        font-size: 13px;
        /* opacity: 0.8; */
        opacity: ${theme('palette.footerPolicyTextOpacity')};
        padding:5px;
        text-decoration: none;
        position: relative;

        :after {
            left: 0;
            bottom: -2px;
            position: absolute;
            width: 0%;
            margin: 0 auto;
            height: 1px;
            background: ${theme('palette.footerPolicyTextHoverLine')};
            content: '';
            position: absolute;
            right: 0;
        }
    }

    a:hover {
            /* opacity: 1;
            -webkit-transition: all 0.2s ease 0s;
		    transition: all 0.2s ease-in-out 0s;
            text-decoration: underline; */

            :after {
                width: 90%;
                transition-duration: 0.5s;
                -webkit-transition-duration: 0.5s;
            }
        }
`;

const Span = styled.div`
  padding-right:10px;
  font-size:13px;
  text-transform: capitalize;

  img {
    width: 34px;
    height: 34px;
    margin: 0px 10px;
  }
`;

const NewLogoWrapper = styled.div`
    width: auto;
    height: 100%;
    display: flex;
    justify-content: center;
    margin: 10px 0px;

    & img {
        width: 140px;
        height: 60px;
        object-fit: contain;
    }
`;

const FooterLogoWrap = styled.div`
    display: flex;
    gap: 1.2em;
    justify-content: center;
    align-items: center;

    & > div{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
`

const CertificateTitle = styled(Tittle)`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    flex-direction: column;
    
    & a {
        color: #fff;
        width: auto;
        text-decoration: underline;
        text-transform: lowercase;
    }
`;

const CertificateText = styled.p`
    width: 51%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-bottom: ${theme('palette.footerCertificationTextMarginBottom')};
`;
